var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',[_c('b-col',{attrs:{"md":"8"}},[_c('b-card',{staticClass:"mb-2"},[_c('b-tabs',[_c('tab-detail'),_c('tab-attach-files'),_c('tab-select')],1)],1)],1),_c('right-tab')],1)}
var staticRenderFns = []

export { render, staticRenderFns }